import React, { useState, useEffect, useRef } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import FAQClient from '../components/FAQClient';

// Placeholder icons - replace with actual icons from a library like Heroicons or React Icons
const PlaceholderCarrierIcon = () => (
  <svg className="w-10 h-10 text-red-500 bg-red-100 p-1 rounded-full" fill="currentColor" viewBox="0 0 20 20">
    <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM5 10a1 1 0 011-1h2V7a1 1 0 112 0v2h2a1 1 0 110 2H9v2a1 1 0 11-2 0v-2H5a1 1 0 01-1-1z" />
  </svg>
);
const CheckIcon = () => ( // Green circle with white check
  <div className="w-5 h-5 rounded-full flex items-center justify-center" style={{ backgroundColor: '#009B36' }}>
    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
    </svg>
  </div>
);
const CircleIcon = () => ( // Light grey outline circle
  <div className="w-5 h-5 rounded-full border-2 border-gray-300"></div>
);
const CurrentCircleIcon = () => ( // Circle with 30% blue fill
  <div className="w-5 h-5 relative">
    <svg className="w-full h-full" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="none" stroke="#e5e7eb" strokeWidth="2.5" />
      <circle 
        cx="12" 
        cy="12" 
        r="10" 
        fill="none" 
        stroke="#3b82f6" 
        strokeWidth="2.5"
        strokeDasharray="18.85 62.83" 
        strokeDashoffset="0" 
        transform="rotate(-90 12 12)" 
      />
    </svg>
  </div>
);
const PlusIcon = () => (
  <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
  </svg>
);
const TruckIcon = () => (
  <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
const PackageIcon = () => (
    <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-14L4 7m8 4v10M4 7v10l8 4m0-14L4 7" />
    </svg>
);
const ChevronDownIcon = () => (
  <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
);
const ChevronRightIcon = () => (
  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
  </svg>
);
const PrintIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 mr-1">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
  </svg>
);

const InfoIcon = () => (
    <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
    </svg>
);

const iconForState = (state) => {
  switch (state) {
    case 'PICKED_UP':
      return <PackageIcon />;
    case 'DELIVERED':
    case 'IN_TRANSIT':
    case 'PICKUP_INROAD':
      return <TruckIcon />;
    case 'PREPARING':
    default:
      return <PlusIcon />;
  }
};

// Times come from the API as UTC epoch millis (`timestamp` / `deliveredAtTimestamp`).
// We format them in the viewer's local timezone (the browser default) and fall back to
// the pre-formatted strings when a raw timestamp isn't available.
const formatEventDate = (ts) =>
  new Date(ts).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
const formatEventTime = (ts) =>
  new Date(ts).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
const formatDeliveredAt = (ts) =>
  new Date(ts).toLocaleString('fr-FR', { weekday: 'long', day: '2-digit', month: 'long', hour: '2-digit', minute: '2-digit' });

// Enrich the raw API payload: add icons and localize times to the viewer's timezone.
const buildTrackingResult = (data) => {
  const shipmentProgress = (data.shipmentProgress || []).map((item) => ({
    ...item,
    icon: iconForState(item.state),
    date: item.timestamp ? formatEventDate(item.timestamp) : item.date,
    time: item.timestamp ? formatEventTime(item.timestamp) : item.time,
  }));
  const estimatedDelivery = data.done && data.deliveredAtTimestamp
    ? formatDeliveredAt(data.deliveredAtTimestamp)
    : data.estimatedDelivery;
  return { ...data, shipmentProgress, estimatedDelivery };
};

const TrackingPage = () => {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [trackingResult, setTrackingResult] = useState(null);
  const resultCardRef = useRef(null);
  const [error, setError] = useState('');
  const [openSections, setOpenSections] = useState({ progress: true, items: false, address: false });
  const printRef = useRef(null);

  useEffect(() => {
    if (trackingResult && resultCardRef.current) {
      const elementPosition = resultCardRef.current.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 75; // Navbar height

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }, [trackingResult]);

  // Effect to check URL parameters and auto-submit if tracking-id and submit=1 are present
  useEffect(() => {
    // Parse URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const trackingId = urlParams.get('tracking-id');
    const shouldSubmit = urlParams.get('submit') === '1';
    
    // If tracking-id is present, set it in the input field
    if (trackingId && trackingId.trim()) {
      // Set the tracking number in state
      setTrackingNumber(trackingId);
      
      // If submit=1 is also present, auto-submit the form
      if (shouldSubmit) {
        // Submit directly without validation since we already checked trackingId.trim()
        setIsLoading(true);
        setError('');
        setTrackingResult(null);
        
        // Make the API call directly instead of using handleSubmit 
        const apiBase = process.env.REACT_APP_API_ENDPOINT;
        fetch(`${apiBase}/v1/tracking/${trackingId.trim()}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            return response.json();
          })
          .then(data => {
            setTrackingResult(buildTrackingResult(data));
          })
          .catch(err => {
            console.error('Error fetching tracking data:', err);
            setError(`Impossible de trouver les informations de suivi pour ${trackingId}. Veuillez vérifier le numéro et réessayer.`);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }
  }, []); // Empty dependency array means this runs once on component mount

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!trackingNumber.trim()) {
      setError('Veuillez entrer un numéro de suivi valide');
      return;
    }
    
    setIsLoading(true);
    setError('');
    setTrackingResult(null);
    
    // Real API call to backend
    const apiBase = process.env.REACT_APP_API_ENDPOINT;
    fetch(`${apiBase}/v1/tracking/${trackingNumber.trim()}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        setTrackingResult(buildTrackingResult(data));
      })
      .catch(err => {
        console.error('Error fetching tracking data:', err);
        setError(`Impossible de trouver les informations de suivi pour ${trackingNumber}. Veuillez vérifier le numéro et réessayer.`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) return;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Suivi - ${trackingResult.trackingNumber}</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; padding: 40px; color: #1a1a1a; font-size: 14px; }
            .logo { font-size: 28px; font-weight: 700; margin-bottom: 24px; }
            .logo span { color: #f89133; }
            .divider { border-top: 1px solid #e5e7eb; margin: 16px 0; }
            .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 8px; }
            .info-label { font-size: 12px; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 2px; }
            .info-value { font-size: 14px; color: #1a1a1a; font-weight: 500; }
            .status-badge { display: inline-block; background: #f0fdf4; color: #009B36; font-weight: 600; font-size: 16px; padding: 6px 16px; border-radius: 6px; border: 1px solid #bbf7d0; }
            .section-title { font-size: 15px; font-weight: 600; color: #374151; margin-bottom: 12px; }
            table { width: 100%; border-collapse: collapse; font-size: 13px; }
            th { text-align: left; padding: 8px 12px; background: #f9fafb; border: 1px solid #e5e7eb; font-weight: 600; color: #374151; }
            td { padding: 8px 12px; border: 1px solid #e5e7eb; color: #4b5563; }
            .footer { margin-top: 32px; font-size: 12px; color: #9ca3af; text-align: center; }
          </style>
        </head>
        <body>
          <div class="logo">Oui<span>Goo</span></div>

          <div class="info-grid">
            <div>
              <p class="info-label">Code de suivi</p>
              <p class="info-value">${trackingResult.trackingNumber}</p>
            </div>
            <div>
              <p class="info-label">Transporteur</p>
              <p class="info-value">${trackingResult.handledBy}</p>
            </div>
          </div>

          <div class="divider"></div>

          <div class="info-grid">
            <div>
              <p class="info-label">Statut</p>
              <p><span class="status-badge">${trackingResult.statusText}</span></p>
            </div>
            <div>
              <p class="info-label">${trackingResult.done ? 'Date de livraison' : 'Date de livraison estimée'}</p>
              <p class="info-value">${trackingResult.estimatedDelivery}</p>
            </div>
          </div>

          ${trackingResult.fromAddress || trackingResult.toAddress ? `
            <div class="divider"></div>
            <div class="info-grid">
              ${trackingResult.fromAddress ? `<div>
                <p class="info-label">Adresse d'expédition</p>
                <p class="info-value">${trackingResult.fromAddress}</p>
              </div>` : ''}
              ${trackingResult.toAddress ? `<div>
                <p class="info-label">Adresse de destination</p>
                <p class="info-value">${trackingResult.toAddress}</p>
              </div>` : ''}
            </div>
          ` : ''}

          ${trackingResult.parcel ? `
            <div class="divider"></div>
            <p class="section-title">Article</p>
            <div class="info-grid">
              <div>
                <p class="info-label">Désignation</p>
                <p class="info-value">${trackingResult.parcel.name}</p>
              </div>
              <div>
                <p class="info-label">Montant</p>
                <p class="info-value">${trackingResult.parcel.amount.toLocaleString('fr-FR')} FCFA</p>
              </div>
            </div>
          ` : ''}

          <div class="divider"></div>
          <p class="section-title">Historique de suivi</p>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Heure</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              ${trackingResult.shipmentProgress.map(event => `
                <tr>
                  <td>${event.date}</td>
                  <td>${event.time}</td>
                  <td>${event.description}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>

          <p class="footer">Document généré depuis ouigoo.co</p>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  };

  const toggleSection = (section) => {
    setOpenSections(prevState => ({
      ...prevState,
      [section]: !prevState[section]
    }));
  };

  const ProgressBar = ({ steps }) => {
    return (
      <div className="grid w-full mb-8 gap-1 sm:gap-2 overflow-hidden" style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}>
        {steps.map((step, index) => (
          <div key={step.name} className="flex flex-col min-w-0">
            {/* Progress bar */}
            <div className="flex h-1.5 mb-4">
              {step.completed && (
                <div className="w-full h-full rounded-full" style={{ backgroundColor: '#009B36' }}></div>
              )}
              {!step.completed && step.current && (
                <div className="w-full h-full rounded-full overflow-hidden">
                  <div className="flex h-full w-full">
                    <div className="w-1/3 h-full" style={{ backgroundColor: '#009B36' }}></div>
                    <div className="w-2/3 h-full bg-gray-300"></div>
                  </div>
                </div>
              )}
              {!step.completed && !step.current && (
                <div className="w-full h-full bg-gray-300 rounded-full"></div>
              )}
            </div>

            {/* Icon and text */}
            <div className="flex items-center min-w-0">
              <div className="flex-shrink-0">
                {step.completed ? <CheckIcon /> : (step.current ? <CurrentCircleIcon /> : <CircleIcon />)}
              </div>
              <span className={`text-[10px] sm:text-xs ml-1 sm:ml-2.5 truncate
                ${step.current ? 'text-black font-semibold' : 'text-gray-500'}
              `}>
                {step.name}
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const CollapsibleSection = ({ title, sectionKey, children }) => (
    <div className="border-t border-gray-200">
      <button 
        onClick={() => toggleSection(sectionKey)} 
        className="w-full flex justify-between items-center py-4 px-6 focus:outline-none"
      >
        <span className="text-md font-semibold text-gray-700">{title}</span>
        {openSections[sectionKey] ? <ChevronDownIcon /> : <ChevronRightIcon />}
      </button>
      {openSections[sectionKey] && (
        <div className="pb-4 px-6 text-sm text-gray-600">
          {children}
        </div>
      )}
    </div>
  );

  return (
    <div className="mx-auto bg-gray-50">
      <div className="max-w-2xl mx-4 sm:mx-auto mt-20 mb-4 sm:mb-10">
        <h1 className="text-6xl font-bold text-left mb-2">
          <span className="text-black">Suivez </span>
          <span className="text-primary-custom">votre</span><br/> 
          <span className="text-black"> colis</span>
        </h1>
        <p className="text-gray-500 text-xl font-medium mb-6 mt-7">Recherchez par numéro de suivi ci-dessous</p>
        <form onSubmit={handleSubmit} className="mb-8">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-grow mb-6 md:mb-0 relative">
              <input
                type="text"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                placeholder="Entrez le numéro de suivi"
                className="w-full px-4 py-3 border border-2 border-gray-400 focus:outline-none focus:border-primary-custom transition h-[52px]"
              />
              {error && <p className="text-red-500 mt-2 text-sm">{error}</p>}
            </div>
            <div className="md:self-start">
              <button
                type="submit"
                disabled={isLoading}
                className="bg-primary-custom hover:bg-primary-custom/90 text-white font-bold px-6 h-[52px] transition duration-300 ease-in-out focus:outline-none disabled:opacity-70 w-full flex items-center justify-center"
              >
                {isLoading ? (
                  <span className="flex items-center justify-center">
                    <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    SUIVRE
                  </span>
                ) : 'SUIVRE'}
              </button>
            </div>
          </div>
        </form>

        <a
          href={`https://wa.me/22945387945?text=${encodeURIComponent(`Bonjour, j'ai besoin d'aide concernant le suivi ${trackingNumber || ''}`.trim())}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-medium text-green-600 hover:text-green-700"
        >
          <FaWhatsapp className="w-5 h-5" /> Besoin d'aide ? Écrivez au support (+229 45387945)
        </a>
      </div>

      {trackingResult && (
        <div ref={(el) => { resultCardRef.current = el; printRef.current = el; }} className="max-w-2xl mx-4 sm:mx-auto bg-white shadow-md rounded-lg">
          {/* Header Section */}
          {/* Header: Tracking Codes, Handled By, Print Button */}
          {/* Header: Tracking Code, Handled By, Print Button */}
          <div className="flex items-start justify-between p-6">
            <div>
              <p className="text-sm text-gray-700">Code de suivi: {trackingResult.trackingNumber}</p>
              <p className="text-sm text-gray-700 mt-1">Cette expédition est gérée par: <span className="font-semibold">{trackingResult.handledBy}</span></p>
            </div>
            <button onClick={handlePrint} className="flex items-center text-sm text-[#143c47] border border-[#143c47] rounded px-3 py-1 hover:bg-[#143c47]/10 focus:outline-none focus:ring-2 focus:ring-[#143c47]/30">
              <PrintIcon /> Imprimer
            </button>
          </div>

          {/* Divider */}
          <div className="border-b border-gray-200"></div>

          {/* Status and Estimated Delivery */}
          <div className="p-6">
            <h3 className="text-2xl font-bold text-gray-800 mb-1">{trackingResult.statusText}</h3>
            <p className="text-sm text-gray-500 mb-4">{trackingResult.done ? "" : "Date de livraison estimée:"} <span className="font-medium text-gray-700">{trackingResult.estimatedDelivery}</span></p>
            <ProgressBar steps={trackingResult.progressSteps} />
            <button className="w-full mt-6 bg-[#143c47] hover:bg-[#143c47]/90 text-white font-medium rounded-md py-3 px-4 flex items-center justify-center gap-2 transition duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6 md:h-6 md:w-6 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              Télécharger notre application pour suivre votre colis en temps réel
            </button>
          </div>

          {/* Shipment Progress Section */}
          <CollapsibleSection title="Progression de l'Expédition" sectionKey="progress">
            <div className="space-y-6">
              {trackingResult.shipmentProgress.map((event, index) => (
                <div key={index} className="flex">
                  <div className="mr-4">
                    {event.icon}
                    {index < trackingResult.shipmentProgress.length - 1 && (
                      <div className="h-full w-0.5 bg-gray-200 mx-auto mt-1"></div>
                    )}
                  </div>
                  <div>
                    <div className="flex items-center">
                      <p className="font-semibold text-gray-700">{event.date} {event.time}</p>
                      {event.current && (
                        <span className="ml-2 px-2 py-0.5 text-xs rounded-full" style={{ backgroundColor: '#e6f7ee', color: '#009B36' }}>Actuel</span>
                      )}
                    </div>
                    <p className="text-gray-600">{event.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </CollapsibleSection>

          {/* Items in Shipment Section */}
          {trackingResult.parcel && (
            <CollapsibleSection title="Article dans l'expédition" sectionKey="items">
              <div>
                <p>{trackingResult.parcel.name}</p>
                <p><strong>Montant:</strong> {trackingResult.parcel.amount.toLocaleString('fr-FR')} FCFA</p>
                {trackingResult.parcel.orderStatusPage && (
                  <a 
                    href={trackingResult.parcel.orderStatusPage} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block mt-2 text-blue-500 font-medium text-base hover:text-blue-800 underline"
                  >
                    Voir la commande
                  </a>
                )}
              </div>
            </CollapsibleSection>
          )}

          {/* Address details Section */}
          <CollapsibleSection title="Détails de l'adresse" sectionKey="address">
            {trackingResult.fromAddress && trackingResult.toAddress ? (
              <div>
                <p><strong>Adresse d'expédition:</strong> {trackingResult.fromAddress}</p>
                <p><strong>Adresse de destination:</strong> {trackingResult.toAddress}</p>
              </div>
            ) : (
              <p>Les détails de l'adresse de livraison apparaîtront ici.</p>
            )}
          </CollapsibleSection>
          
          {/* Need Help Section */}
          <div className="p-6 bg-gray-50 rounded-b-lg">
            <h4 className="text-md font-semibold text-gray-700 mb-3">Besoin d'aide avec votre livraison?</h4>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
                <button onClick={() => window.location.href = `/complaint?tracking-id=${trackingResult.trackingNumber}`} className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-700 font-medium py-2 px-4 rounded-md text-sm flex items-center justify-center">
                    <InfoIcon />
                    <span className="ml-2">Je n'ai pas reçu cet article</span>
                </button>
                <button onClick={() => window.location.href = `/complaint?tracking-id=${trackingResult.trackingNumber}`} className="flex-1 bg-blue-50 hover:bg-blue-100 text-blue-700 font-medium py-2 px-4 rounded-md text-sm flex items-center justify-center">
                    <InfoIcon />
                    <span className="ml-2">Signaler un problème</span>
                </button>
            </div>
          </div>
        </div>
      )}
      <div className="mt-20">
        <FAQClient />
      </div>
    </div>
  );
};

export default TrackingPage;

